/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Reference_Dataset_Weight_UnitInputs */

const en_reference_dataset_weight_unit = /** @type {(inputs: Reference_Dataset_Weight_UnitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Weight units`)
};

/**
* | output |
* | --- |
* | "Weight units" |
*
* @param {Reference_Dataset_Weight_UnitInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const reference_dataset_weight_unit = /** @type {((inputs?: Reference_Dataset_Weight_UnitInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Reference_Dataset_Weight_UnitInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_reference_dataset_weight_unit(inputs)
});